import {
    LOGOUT,
    UPDATE_PROFILE,
    UPDATE_PROFILE_FAIL,
    UPDATE_PROFILE_SUCCESS,
    CLEAR_FROM
} from '../actionTypes';

const initialState = {
    loading: false
};

export const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PROFILE:
            return { ...state, loading: true };
        case UPDATE_PROFILE_SUCCESS:
            return { ...state, loading: false, user: action.payload, from: action.from };
        case UPDATE_PROFILE_FAIL:
            return { ...state, loading: false, error: action.payload };
        case CLEAR_FROM:
            return { ...state, from: '' };
        case LOGOUT:
            return {};
        default:
            return state;
    }
};
